import React from 'react';
import ReactDOM from 'react-dom';

import StockistsApp from '../components/stockists/StockistsApp';

document.addEventListener('DOMContentLoaded', function() {
  ReactDOM.render(
    <StockistsApp />,
    document.getElementById('stockists-app'),
  );
});
